import React from "react";
import Box from "@mui/material/Box";

import ActionModal from "../../components/modals/action-modal";
import InviteForm from "./InviteForm";

export default function ScannerModal({ projectId, client, onClose, onSuccess }) {
  return (
    <ActionModal
      open
      id="inviteUserModal"
      title="Invite User"
      maxWidth={600}
      onClose={onClose}
      disableTransition
    >
      <Box mt={3}>
        <InviteForm projectId={projectId} client={client} onSuccess={onSuccess} />
      </Box>
    </ActionModal>
  );
}
